/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { arrayOf, shape, string } from 'prop-types';

import { getWebPImage } from 'utils/image';

import ArticleCard from 'components/ArticleCard/ArticleCard';

import styles from './articles-block.scss';

/**
 * This is the ArticlesBlock component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class ArticlesBlock extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    title: string,
    items: arrayOf(
      shape({
        title: string.isRequired,
        content: string.isRequired,
        image: string.isRequired,
        url: string,
      })
    ),
  };

  static defaultProps = {
    title: null,
    items: [],
  };

  /**
   * Render ArticlesBlock.
   *
   * @return {Object}
   */
  render() {
    const { title: sectionTitle, items } = this.props;

    return (
      <div className={styles.wrapper}>
        {/* {sectionTitle && (
          <h2 className={styles.sectionTitle}>{sectionTitle}</h2>
        )} */}

        <div className={styles.items}>
          {items.map(({ title, content, image, url }, index) => (
            <div className={styles.item} key={`article-${url}-${index}`}>
              <ArticleCard
                {...{
                  title,
                  content,
                  url,
                  image: getWebPImage(image),
                }}
                isCompact
                hasButton
                hasSquareImage
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}
